import React from 'react';
import useExperiment from './useExperiment';

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

/**
 * Inject experiment state into a component as mapped props.
 *
 * Variant-only experiment:
 * export default withExperiment('signInButtonColor', ({ variant }) => ({
 *   color: variant,
 * }))(HeaderSignInRewardsLink);
 *
 * Payload-only usage:
 * export default withExperiment('heroBannerLayout', ({ payload }) => ({
 *   heroLayout: payload.layout,
 *   heroCopy: payload.copy,
 * }))(HeroBanner);
 *
 * Variant + payload + readiness:
 * export default withExperiment('checkoutCtaCopy', ({ variant, payload, isReady }) => ({
 *   ctaVariant: variant,
 *   ctaLabel: payload.copy,
 *   isExperimentReady: isReady,
 * }))(CheckoutButton);
 */
const withExperiment = (experimentId, mapExperimentToProps = () => ({})) => (WrappedComponent) => {
  const WithExperiment = (props) => {
    const experiment = useExperiment(experimentId);
    const experimentProps = mapExperimentToProps(experiment, props) || {};

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent {...props} {...experimentProps} />;
  };

  WithExperiment.displayName = `withExperiment(${getDisplayName(WrappedComponent)})`;

  return WithExperiment;
};

export default withExperiment;
